const Topic = ["Cloud Intercom Solutions","Emergency Intercom Solutions","Home Automation Integration",
    "Office Intercom Solutions","Residential Intercom Solutions","Visitor Management Systems","Apply Filter","Smart Intercom Products"];

let topicList = [];
for(let i in Topic)
    topicList.push({ID:i,Name:Topic[i]});


const DocumentType = ["Poster","Roll-up Poster"];

let documentTypeList = [];
for(let i in DocumentType)
    documentTypeList.push({ID:i,Name:DocumentType[i]});

export { Topic,topicList,DocumentType,documentTypeList };


